import { ModalType } from 'const';
import * as Models from 'models';
import { Action } from './models';

export function isUpdateDocumentAction(
  action: Action.IShowModal<unknown>,
): action is Action.IShowModal<Models.DocumentSaveWindowOptions | Models.EditReusableLayoutWindowOptions> {
  return [ModalType.DOCUMENT_SAVE, ModalType.EDIT_REUSABLE_LAYOUT].includes(action.payload.modalType);
}
